import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogDescription, DialogHeader } from './ModalComponent'
import { IoMdClose } from 'react-icons/io'
import { IoCloudUploadOutline } from 'react-icons/io5'
import InputWithLabel from '../Form/InputWithLabel'
import { useFormik } from 'formik'
import TextArea from '../Form/TextArea'
import Button from '../Button/Button'
import { useDispatch, useSelector } from 'react-redux'
import { addNewRecommendation, getRecommendationListData, updateRecommendation } from '../../../redux/actions/recommendation.action'
import { IoClose } from "react-icons/io5";
import { recommendationSchema } from '../../../config/schema'
import ButtonLoading from '../../custom/ButtonLoading'
import { toast } from 'react-toastify'


const AddRecommendation = ({ data, setData }) => {
    const [profile, setProfile] = useState()

    const dispatch = useDispatch();
    const { loading } = useSelector((state) => state.recommendation)

    const formik = useFormik({
        initialValues: {
            profile: "",
            name: "",
            link: "",
            offer: "",
            description: ""
        },
        validationSchema: recommendationSchema,
        onSubmit: (values) => {
            const formData = new FormData();
            values?.profile instanceof File && formData.append("recommendation_img", values?.profile);
            data?.mode === "edit" && formData.append("_id", data?.data?._id)
            formData.append("name", values?.name);
            formData.append("link", values?.link);
            formData.append("offer", values?.offer);
            formData.append("description", values?.description)
            data?.mode === "add" ? dispatch(addNewRecommendation(formData)).unwrap().then(() => {
                setData({
                    open: false,
                    data: null
                })
                dispatch(getRecommendationListData({ page: 1, limit: 10, search: "" }))
                formik.resetForm();
                setProfile("")
            }).catch((err) => {
                toast.error(err?.ResponseMsg)
            }) : dispatch(updateRecommendation(formData)).unwrap().then(() => {
                setData({
                    open: false,
                    data: null
                })
                dispatch(getRecommendationListData({ page: 1, limit: 10, search: "" }))
                formik.resetForm();
                setProfile("")
            }).catch((err) => {
                toast.error(err?.ResponseMsg)
            })
        }
    })

    const onClose = () => {
        setData({
            open: false,
            data: null,
            mode: null
        })
    }

    useEffect(() => {
        if (data?.data) {
            formik.setValues({
                profile: data?.data?.recommendation_img,
                name: data?.data?.name,
                link: data?.data?.link,
                offer: data?.data?.offer,
                description: data?.data?.description
            })
            setProfile(data?.data?.recommendation_img)
        }
    }, [data?.open])

    return (
        <Dialog open={data.open} onOpenChange={onClose}>
            <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} className="max-w-xl">
                <DialogHeader>
                    <div className="flex justify-between items-center w-full border-b border-[#F1F5F9] px-4 py-4">
                        <h1 className="text-[#0F172A] text-lg font-bold">{data?.mode === "add" ? "Add" : "Edit"}  Recommendation</h1>
                        <div
                            className="bg-[#F8FAFC] cursor-pointer w-10 h-10 rounded-lg flex justify-center items-center"
                            onClick={onClose}
                        >
                            <IoMdClose className="text-[#64748B]" />
                        </div>
                    </div>
                </DialogHeader>
                <DialogDescription className="">
                    <div className='px-6 pb-6 space-y-5'>
                        <div className='flex flex-col'>
                            <p className="text-sm font-semibold text-[#0F172A]">Photo</p>
                            {!profile ? (
                                <label class="w-32 h-32 flex flex-col items-center justify-center  bg-[#F8FAFC] text-blue rounded-lg  cursor-pointer">
                                    <IoCloudUploadOutline className="text-2xl font-bolder text-[#2563EB]" />
                                    <span class="mt-2 text-xs font-semibold text-[#2563EB]">
                                        Upload Image
                                    </span>
                                    <input
                                        type="file"
                                        class="hidden"
                                        name="profile"
                                        accept="image/png, image/gif, image/jpeg"
                                        onChange={(e) => {
                                            setProfile(e.target.files[0]);
                                            formik.setFieldValue(
                                                "profile",
                                                e.currentTarget.files[0]
                                            );
                                        }}
                                    // onChange={(e) => setProfile(e.target.files[0])}
                                    />
                                </label>
                            ) : (
                                <div className='relative w-[130px] h-[130px]'>
                                    <img
                                        src={profile instanceof File ? URL.createObjectURL(profile) : profile}
                                        className="w-[130px] h-[130px] object-cover rounded-md"
                                    />
                                    <div className='flex absolute items-center -top-1 -right-1 justify-center size-[20px] rounded-full bg-[#D94332] cursor-pointer' onClick={() => { setProfile(null); formik.setFieldValue("profile", "") }}>
                                        <IoClose className='text-white size-4' />
                                    </div>
                                </div>
                            )}
                            {formik.errors.profile && formik?.touched?.profile ? (
                                <div className="text-red-400 text-sm mt-1">{formik.errors.profile}</div>
                            ) : null}
                        </div>
                        <InputWithLabel
                            name="name"
                            label="Name"
                            placeholder="Name"
                            type={"text"}
                            className='py-3.5'
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={formik.errors.name}
                            touched={formik.touched.name}
                        />
                        <InputWithLabel
                            name="link"
                            label="Link"
                            placeholder="Link"
                            type={"text"}
                            className='py-3.5'
                            value={formik.values.link}
                            onChange={formik.handleChange}
                            error={formik.errors.link}
                            touched={formik.touched.link}
                        />
                        <InputWithLabel
                            name="offer"
                            label="Offers"
                            placeholder="Offers"
                            type={"text"}
                            className='py-3.5'
                            value={formik.values.offer}
                            onChange={formik.handleChange}
                            error={formik.errors.offer}
                            touched={formik.touched.offer}
                        />
                        <div className='flex flex-col'>
                            <TextArea name="description" label="Description" value={formik.values.description} placeholder="Add Description" onChange={formik.handleChange} />
                            {formik.errors.description && formik?.touched?.description ? (
                                <div className="text-red-400 text-sm mt-1">{formik.errors.description}</div>
                            ) : null}
                        </div>
                        <div className='w-full '>
                            <Button
                                className={`py-3.5 rounded-[10px] bg-[#383F90] font-medium text-lg w-full `}
                                text={loading ? <ButtonLoading /> : data?.mode === 'add' ? "Add" : "Update"}
                                type={true}
                                onClick={formik.handleSubmit}
                            />
                        </div>
                    </div>
                </DialogDescription>
            </DialogContent>
        </Dialog>
    )
}

export default AddRecommendation